import { styled } from "goober";
import type { CSSProperties, ReactNode } from "react";
import { navEnterStyles } from "../hooks/useNavTransition";

const StyledHeader = styled("header")`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  opacity: 1;
  transform: none;
  transition:
    opacity var(--motion-base) var(--ease-out),
    transform var(--motion-base) var(--ease-out);
  &[data-entering="true"] {
    opacity: 0;
    transform: translateX(-32px);
    pointer-events: none;
  }
  &[data-leaving="true"] {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 0;
    opacity: 0;
    transform: translateX(-32px);
    pointer-events: none;
  }
`;

const Horizontal = styled("div")`
  display: flex;
  align-items: center;
  ${navEnterStyles}
`;

const Middle = styled("div")`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
`;

type Props = {
  left?: ReactNode;
  middle?: ReactNode;
  right?: ReactNode;
  mobile?: boolean;
  hidden?: boolean;
  leaving?: boolean;
  entering?: boolean;
  navEnter?: "left" | "right";
  style?: CSSProperties;
};

export function Header({
  left,
  middle,
  right,
  mobile,
  hidden,
  leaving,
  entering,
  navEnter,
  style,
}: Props) {
  if (hidden) return null;
  return (
    <StyledHeader
      data-leaving={leaving}
      data-entering={entering}
      inert={leaving}
      style={{ ...(mobile && { padding: 8 }), ...style }}
    >
      <Horizontal
        data-nav-enter={navEnter}
        style={
          mobile ? { minWidth: 0, flex: 1, overflow: "hidden" } : undefined
        }
      >
        {left}
      </Horizontal>
      {middle && !mobile && <Middle>{middle}</Middle>}
      <Horizontal style={mobile ? { flexShrink: 0 } : undefined}>
        {right}
      </Horizontal>
    </StyledHeader>
  );
}
